import React from "react";
import "./privacy.css";
import Topbar from "../../components/Topbar/Topbar";
import Policies from "../../components/Policies/Policies";
import Footer from "../../components/Footer/Footer";

const privacy=()=>{
    return(
        <>
            <Topbar/>
            <div className="privacy-container">
                <Policies/>
                <Footer/>
            </div>
        </>
    )
}

export default privacy;